import { useState, type FC } from 'react';
import { NotesList } from 'components/common/notes-list';
import { useQuery } from '@tanstack/react-query';
import { getCustomerNotes } from 'queries';

type Props = Readonly<{
  customerId?: string;
}>;

export const CustomerNotes: FC<Props> = ({ customerId }) => {
  const [pagination, setPagination] = useState({ current_page: 1, per_page: 10 });

  // Handle page or pageSize change
  const handleTableChange = (page: number, pageSize: number) => {
    setPagination({ current_page: page, per_page: pageSize });
  };

  const {
    data: notes,
    isLoading,
    error,
  } = useQuery(
    ['getCustomerNotes', { id: customerId, page: pagination.current_page, per_page: pagination.per_page }],
    getCustomerNotes,
  );

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading notes</div>;

  const paginationMetadata = notes
    ? {
        total: notes.meta?.total ?? 0,
        current_page: pagination.current_page,
        per_page: pagination.per_page,
        onChange: handleTableChange,
      }
    : undefined;

  return <NotesList notes={notes?.data} paginationMetadata={paginationMetadata} />;
};
